import * as t from './actionTypes';

const initialState = {
  zuoraCredentials: {},
  trialExpirationDate: null,
  zuoraProducts: {
    isLoading: false,
    products: {},
  },
  zuoraRatePlans: {
    isLoading: false,
    ratePlans: {},
  },
  zuoraObjectManipulation: {},
};

const billingReducer = (state = initialState, action) => {
  switch (action.type) {
    case t.FETCH_ZUORA_CREDENTIALS_RESPONSE: {
      return {
        ...state,
        ...action.credentials,
      };
    }
    case t.FETCH_TRIAL_EXPIRATION_DATE_RESPONSE: {
      return {
        ...state,
        trialExpirationDate: action.trialExpirationDate,
        paymentPlanId: action.paymentPlanId,
      };
    }
    case t.UPDATE_TRIAL_EXPIRATION_DATE_RESPONSE: {
      return {
        ...state,
        trialExpirationDate: action.trialExpirationDate,
      };
    }
    case t.GET_CREDIT_CARDS_RESPONSE: {
      return {
        ...state,
        creditCards: action.creditCardInfo,
      };
    }
    case t.GET_CREDIT_CARDS_ERROR: {
      return {
        ...state,
        creditCardsError: true,
      };
    }
    case t.GET_ZUORA_PRODUCTS_REQUEST: {
      return {
        ...state,
        zuoraProducts: {
          ...state.zuoraProducts,
          isLoading: true,
        },
      };
    }
    case t.GET_ZUORA_PRODUCTS_SUCCESS: {
      return {
        ...state,
        zuoraProducts: {
          ...state.zuoraProducts,
          isLoading: false,
          products: action.result,
        },
      };
    }
    case t.GET_ZUORA_RATEPLANS_REQUEST: {
      return {
        ...state,
        zuoraRatePlans: {
          ...state.zuoraRatePlans,
          isLoading: true,
        },
      };
    }
    case t.GET_ZUORA_RATEPLANS_SUCCESS: {
      return {
        ...state,
        zuoraRatePlans: {
          ...state.zuoraRatePlans,
          isLoading: false,
          ratePlans: {
            ...state.zuoraRatePlans.ratePlans,
            // this is '...' because action.data sometimes contains a size field
            ...action.data,
          },
        },
      };
    }

    case t.CREATE_ZUORA_OBJECT_REQUEST: {
      return {
        ...state,
        zuoraObjectManipulation: {
          ...state.zuoraObjectManipulation,
          isLoading: true,
        },
      };
    }

    case t.UPDATE_ZUORA_OBJECT_REQUEST: {
      return {
        ...state,
        zuoraObjectManipulation: {
          ...state.zuoraObjectManipulation,
          isLoading: true,
        },
      };
    }

    case t.DELETE_ZUORA_OBJECT_REQUEST: {
      return {
        ...state,
        zuoraObjectManipulation: {
          ...state.zuoraObjectManipulation,
          isLoading: true,
        },
      };
    }

    case t.OBJECT_MANIPULATION_FINISHED: {
      return {
        ...state,
        zuoraObjectManipulation: {
          ...state.zuoraObjectManipulation,
          isLoading: false,
        },
      };
    }

    default: {
      return state;
    }
  }
};

export default billingReducer;
